import React from 'react';
import styles from './preview.module.scss';
import UniImage from '../../components/UniImage';

const Preview = ({ config }) => {
    const { theme, menu, tabbar_style } = config;

    // 应用主题变量到预览容器
    const themeStyle = {
        '--td-brand-color': theme['--td-brand-color'],
        '--td-brand-light-color': theme['--td-brand-light-color'],
        '--td-sc-border-radius': theme['--td-sc-border-radius'],
        '--td-sc-margin': theme['--td-sc-margin']
    };

    return (
        <div className={styles.previewContainer} style={themeStyle}>
            <div className={styles.phoneFrame}>
                <div className={styles.screen}>
                    {/* 示例卡片 */}
                    <div className={styles.card}>
                        <div className={styles.cardTitle}>示例卡片</div>
                        <div className={styles.cardContent}>
                            <div className={styles.button}>主题色按钮</div>
                            <div className={styles.text}>这是一段示例文本内容</div>
                        </div>
                    </div>

                    {/* 主题色卡片 */}
                    <div className={styles.card}>
                        <div className={styles.cardTitle}>主题色展示</div>
                        <div className={styles.cardContent}>
                            <div className={styles.colorBlock}>
                                <div className={styles.colorItem} style={{ color: 'white', background: theme['--td-brand-color'] }}>
                                    <span>主题色</span>
                                </div>
                                <div className={styles.colorItem} style={{ color: theme['--td-brand-color'], background: theme['--td-brand-light-color'] }}>
                                    <span>背景色</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 底部菜单 */}
                    <div className={`${styles.tabbar} ${styles[tabbar_style]}`}>
                        {menu.map((item, index) => (
                            <div key={index} className={styles.tabbarItem}>
                                <UniImage
                                    src={item.icon}
                                    alt={item.text}
                                    className={styles.tabbarIcon}
                                    width={24}
                                    height={24}
                                />
                                <div className={styles.tabbarText}>{item.text}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Preview;